export default __webpack_public_path__ + "static/media/nflStaff12.3d6e591d.jpg";